import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-player-vimeo',
  templateUrl: './player-vimeo.component.html',
  styleUrls: ['./player-vimeo.component.css']
})
export class PlayerVimeoComponent implements OnInit {

  @Input() servicePath: string;
  videoSource: SafeResourceUrl;
  
  constructor(private sanitizer: DomSanitizer) { }
  
  ngOnInit() {
    this.videoSource = this.sanitizer.bypassSecurityTrustResourceUrl(this.servicePath);
    // this.videoSource = this.servicePath;
  }

}
